/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type CalendarIntegrationType =
  (typeof CalendarIntegrationType)[keyof typeof CalendarIntegrationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarIntegrationType = {
  DOMAIN_WIDE: 'DOMAIN_WIDE',
  INDIVIDUAL: 'INDIVIDUAL',
} as const;
